<template>
  <div class="animated fadeIn list-of-cashflow">
    <b-card>
      <div slot="header">Revaluation AP Foreign Currency(FCY) 
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="posting()" :key="postingLabel">
              <i class="fa fa-paper-plane"></i> {{postingLabel}}
          </button>
          <button class="btn btn-primary mr-1" @click="printjv()">
              <i class="fa fa-print"></i> Print JV
          </button>
         <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row >
        <b-col lg="4">
          <b-form-group label-cols=3 label="Periode">
                <vue-monthly-picker v-model="filter.periode" dateFormat="MMMM YYYY" :monthLabels="monthLabels" @selected="onChangeMonth"></vue-monthly-picker>
          </b-form-group>
        </b-col>
        <b-col lg="2">
            <b-button class="btn btn-success" @click="process()" > <i class="fa fa-play"></i> Process</b-button>
        </b-col>
      </b-row>
      <div class="report-wraper">
          <table>
              <thead>
                <tr>
                    <th width="200px" rowspan="2">Vendor/Supplier</th>
                    <th width="120px" rowspan="2">AP.Number</th>
                    <th width="90px" rowspan="2"> AP.Date</th>
                    <th width="250px" rowspan="2"><div style="width: 200px; overflow: hidden; display: inline-block; white-space: nowrap;">AP. Description</div></th>
                    <th style="text-align:center" width="50px" rowspan="2">$,¥</th>
                    <th colspan="3" style="text-align:center">BEGINING BALANCE</th>
                    <th colspan="3" style="text-align:center;">ADD/NEW INVOICE</th>
                    <th colspan="3" style="text-align:center;">PAYMENT (DEBIT)</th>
                    <th colspan="3" style="text-align:center;">ENDING BALANCE</th>
                    <th style="text-align:right" width="100px" >Difference</th>
                </tr>
                <tr>
                    <th width="90px">Value (FCY)</th>
                    <th width="60px">Exch. Rate</th>
                    <th width="100px">Value ({{uanguser}})</th>
                    <th width="90px">Value (FCY)</th>
                    <th width="60px">Exch. Rate</th>
                    <th width="100px">Value ({{uanguser}})</th>
                    <th width="90px">Value (FCY)</th>
                    <th width="60px">Exch. Rate</th>
                    <th width="100px">Value ({{uanguser}})</th>
                    <th width="90px">Value (FCY)</th>
                    <th width="60px">Exch. Rate</th>
                    <th width="100px">Value ({{uanguser}})</th>
                    <th width="100px">Value ({{uanguser}})</th>
              </tr>
              </thead>
              <tbody>
                  <tr v-for="row in rekondata" :key="row.apinvkey">
                      <td width="150px"><div style="width: 210px; overflow: hidden; display: inline-block; white-space: nowrap;">{{row.vendorinfo}}</div></td>
                      <td width="120px">{{row.nomor}}</td>
                      <td width="90px"> {{row.tanggal| moment("DD MMM YYYY")}}</td>
                      <td width="210px"><div style="width: 210px; overflow: hidden; display: inline-block; white-space: nowrap;">{{row.uraian}}</div></td>
                      <td style="text-align:right" width="50px">{{row.matauang}} </td>
                      <td v-if="(row.totalaw)" style="text-align:right" width="100px">{{row.totalaw | numFormat('0,0.00')}}</td>
                      <td v-else width="100px"></td>
                      <td v-if="(row.kursaw)" style="text-align:right" width="90px">{{row.kursaw | numFormat('0,0.00')}}</td>
                      <td v-else width="90px"></td>
                      <td v-if="(row.idraw)" style="text-align:right" width="100px">{{row.idraw | numFormat('0,0.00')}}</td>
                      <td v-else width="100px"></td>
                      <td v-if="(row.totalnew)" style="text-align:right" width="100px">{{row.totalnew | numFormat('0,0.00')}}</td>
                      <td v-else width="100px"></td>
                      <td v-if="(row.kursnew)" style="text-align:right" width="90px">{{row.kursnew | numFormat('0,0.00')}}</td>
                      <td v-else width="90px"></td>
                      <td v-if="(row.idrnew)" style="text-align:right" width="100px">{{row.idrnew | numFormat('0,0.00')}}</td>
                      <td v-else width="100px"></td>
                      <td v-if="(row.totalpay)" style="text-align:right" width="100px">{{row.totalpay | numFormat('0,0.00')}}</td>
                      <td v-else width="100px"></td>
                      <td v-if="(row.kurspay)" style="text-align:right" width="90px">{{row.kurspay | numFormat('0,0.00')}}</td>
                      <td v-else width="90px"></td>
                      <td v-if="(row.idrpay)" style="text-align:right" width="100px">{{row.idrpay | numFormat('0,0.00')}}</td>
                      <td v-else width="100px"></td>
                      <td v-if="(row.totalak)" style="text-align:right" width="100px">{{row.totalak | numFormat('0,0.00')}}</td>
                      <td v-else width="100px"></td>
                      <td v-if="(row.kursak)" style="text-align:right" width="90px">{{row.kursak | numFormat('0,0.00')}}</td>
                      <td v-else width="90px"></td>
                      <td v-if="(row.idrak)" style="text-align:right" width="100px">{{row.idrak | numFormat('0,0.00')}}</td>
                      <td v-else width="100px"></td>
                      <td v-if="(row.selisih)" style="text-align:right" width="100px">{{row.selisih | numFormat('0,0.00')}}</td>
                      <td v-else width="100px"></td>
                  </tr>
                </tbody>
          </table>
      </div>
      <hr>
      <b-row >
        <b-col md="2">Total Begining :<span class="input-group-text">{{uanguser}} {{subtotal.totalAw | numFormat('0,0.00')}}</span></b-col>
        <b-col md="2">Add/New Invoice : <span class="input-group-text">{{uanguser}} {{subtotal.totalNew | numFormat('0,0.00')}}</span></b-col>
        <b-col md="2">Payment/Settlement  : <span class="input-group-text">{{uanguser}} {{(subtotal.totalPay) | numFormat('0,0.00')}}</span></b-col>
        <b-col md="2">Total Ending  : <span class="input-group-text">{{uanguser}} {{(subtotal.totalAk) | numFormat('0,0.00')}}</span></b-col>
        <b-col md="2">Difference (Gain/Loss)<span class="input-group-text">{{uanguser}} {{subtotal.selisih | numFormat('0,0.00')}}</span></b-col>
        <b-col class="text-right">
          <button class="btn btn-primary mt-2 mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </b-col>
      </b-row>
    </b-card>
      <b-modal v-model="showPostingConfirm" title="Posting Record?" :centered="true" @ok="postingData">
        <p class="mb-1">The <strong>Revaluation AP Foreign Currency(FCY)</strong> will be Posted to Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">You can unpost as long as <strong>Accounting Periode</strong> stil open</p>
      </b-modal>
      <b-modal v-model="showUnpostConfirm" title="Un Posting Record?" :centered="true" @ok="unpostData">
        <p class="mb-1">The <strong>Revaluation AP Foreign Currency(FCY)</strong> will be UnPosted from Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">Data Journal will be removed from <strong>Accounting</strong></p>
      </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable  title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>

  </div>
</template>

<style lang="scss" scoped>
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;

        table {
            font-size: smaller;
            th {
                border-bottom: 1px solid #D1D1D1;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }              
            td {
                border-bottom: 1px solid #f5f5f5;
                padding: 0 10px;
                height: 25px;
            }
            
            td.tebal {
                font-weight: bold;
            }
            
            td.subtotal {
                border-top: 2px solid #000 !important;
            }
            
            td.total {
                border-top: 2px solid #000 !important;
                background: #e6e6e6 !important;
            }
            
            td.grdtotal {
                border-top: 2px solid #000!important;
                border-bottom: 2px double #000 !important;
                background: #e6e6e6 !important;
            }
            tbody tr:hover {
                background-color: rgba(0, 0, 0, 0.05) !important;
                cursor: default;
            }
        }
    }
 
</style>

<script>
import moment from 'moment';
import VueMonthlyPicker from 'vue-monthly-picker';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import apreval from "../../apis/apreval";
import dropdown from "../../data/dropdown";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    filter: {
        tgl1: { required },
        tgl2: { required },
    },
  }, 
  data() {
    return {
      horizontal: true,
      isLoading:false,
      showReport:false,
      showPostingConfirm: false,
      showUnpostConfirm: false,
      postingLabel: 'Posting',
      reportUrl: null,
      filter: {tgl1:'',tgl2:''},
      uanguser: this.$store.state.user.matauang,
      monthLabels:dropdown.monthLabels,
      rekondata : [],
      subtotal : {posting : -1},
    };
  },
  components: {VueMonthlyPicker,Loading},
  computed: {
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    },
  },
  created: async function(){
        this.filter.periode = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        this.filter.tgl1=this.$store.state.user.tglaktif;
        this.filter.tgl2= this.filter.periode.format('YYYY-MM-DD');
  },  
  methods: {
    updateTgl1: function() {
        var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
        this.filter.tgl1=`${tgl2.format('YYYY-MM')}-01`;
        // this.tahun=tgl2.format('YYYY');
        // this.$forceUpdate();
        this.filter.tgl2=tgl2.endOf('month').format('YYYY-MM-DD');
        console.log('this.filter.tgl2 : ',this.filter.tgl2);
    },
    onChangeMonth: async function (){
        var tgl=this.filter.periode;
        this.filter.tgl1=tgl.startOf('month').format('YYYY-MM-DD');
        this.filter.tgl2=tgl.endOf('month').format('YYYY-MM-DD');
        this.subtotal.posting = -1;
        console.log('this.filter : ',this.filter);
        this.$forceUpdate();
    },  

    process: async function() {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
        this.isLoading=true;
        try {
            const result = await apreval.process(this.filter);
            this.rekondata =  result[0];
            this.subtotal = result[1][0];
            if ((this.subtotal.posting || 0) == 0) {
                this.postingLabel='Posting';     
            } else {
                this.postingLabel='Un Posting';     
            }
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
        }
       }
    },
    confirmAction: function() {
        toastr.info('Klik Pada TRX. NUMBER untuk PRINT VOUCHER');
    },
    posting: async function () {
      if (this.subtotal.posting !== -1) {
        if ((this.subtotal.posting || 0) == 0) {
            this.showPostingConfirm = true;
        } else { 
        // if (this.subtotal.posting == 1) {
            this.showUnpostConfirm = true;
        }
      } else {
        toastr.warn('Please do Process before Posting/UnPosting!');
      }
    }, 
    postingData: async function(){
        this.isLoading=true;
        try {
            await apreval.posting(this.filter);
            this.subtotal.posting=1;
            this.postingLabel='Un Posting';     
            // this.printjv();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
        }
    },  
    unpostData: async function(){
        this.isLoading=true;
        try {
            await apreval.postingUndo(this.filter);
            this.subtotal.posting=0;
            this.postingLabel='Posting';     
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
        }
    },  
    printjv: async function()
    {
      if ((this.subtotal.posting || 0) == 1) {
          try {
                this.showReport=true;
              this.reportUrl= await apreval.printjv(this.filter);
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
              this.isLoading=false;
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please do Posting before Print JV!');
        }
    },
    exportxls: async function() {
      if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
      } else {
        this.isLoading=true;
        try {
            const response = await apreval.exportxls(this.filter);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
      }
    },    
    close(){
      router.push("home");
    }
  }
};
</script>
